import React from 'react';
import { Text } from '@radix-ui/themes';
import caseStudy from "../../../assets/images/caseStudy.png";
import OpenClassInteraction from 'components/classroom/components/backup/OpenClassInteraction';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store';

interface CsSetupProps {
    roomClient: any;
}

const CsSetup: React.FC<CsSetupProps> = ({roomClient}) => {
  const batchData = useSelector((state: RootState) => state.live.settings?.batch);
  return (
    // <div className="flex flex-1 h-full flex-col items-center justify-center">
    //   <img
    //     src={caseStudy}
    //     alt="Case Study"
    //     className="h-[20vh] w-[35vw] object-contain"
    //   />
    //   <Text className="text-white py-4 text-center font-[Lato-Regular] text-base w-[60vw]">
    //     Case study setup in progress...
    //   </Text>
    //   <Text className="text-[#E9E0FA] text-center font-[Lato-Regular] text-base w-[60vw] -mt-2">
    //     Standby ... you will shortly commence<br />the Case Study & Analysis
    //   </Text>
    // </div>
    <div>
      <div className="flex items-center justify-center my-6">
        <div className="bg-[rgba(33,32,37,0.8)] w-fit rounded-lg py-2 px-4 gap-4 border-[1px] border-[#545455] flex flex-row items-center justify-center">
          <Text className="text-[#E9BE50] text-[10px] font-bold"> Case study setup in progress ...</Text>
          <div className="h-[8px] w-[8px] rounded-full bg-[#43A047] border-[1px] border-[#E9BE50]"></div>
        </div>
      </div>
      <OpenClassInteraction roomClient={roomClient} tableDetails={batchData?.participants} />
    </div>
  );
};

export default CsSetup;